import Service from '@/service/index.js';
import getSummaries from '@/utils/mixins/transaction-get-summaries.js';
export default {
  mixins: [getSummaries],
  props: {
    previewContract: {
      type: Object,
      default: {}
    },
    closeBtn: {
      type: Boolean,
      default: false
    },
    projectSubType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      id: '',
      dialogFormVisible: true,
      massifType: [],
      sihuangTypeArr: [],
      payTypeArr: [],
      citytitle: ''
    };
  },
  computed: {
    previewPageContract () {
      if (this.previewContract && this.previewContract.assetsInfo) {
        return JSON.parse(this.previewContract.assetsInfo);
      }
    },
    transferTxt5 () {
      if (this.previewContract.isSublet5) {
        if (this.previewContract.isSublet5 === '2') {
          return '转让';
        } else if (this.previewContract.isSublet5 === '1') {
          return '出租';
        }
      } else {
        return '';
      }
    },
    transferTxt6 () {
      if (this.previewContract.isSublet6) {
        if (this.previewContract.isSublet6 === '2') {
          return '转让';
        } else if (this.previewContract.isSublet6 === '1') {
          return '出租';
        }
      } else {
        return '';
      }
    }
  },
  created () {
    const obj = {
      MASSIF_TYPE: 'massifType',
      PAY_TYPE: 'payTypeArr',
      SIHUANG_TYPE: 'sihuangTypeArr'
    };
    Object.keys(obj).forEach((key) => {
      Service.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          this[obj[key]] = res.data;
        }
      });
    });
  },
  mounted () {
  },
  methods: {
    handleScroll () {
      const scrollTop = this.$refs.box.scrollTop; // 获取滑动距离
      if (scrollTop >= 1600) {
        this.$emit('enabledBtn');
      }
    },
    getSummaries (param) {
      console.log(param);
      const sumFlag = ['area'];
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        } else {
          if (sumFlag.includes(column.property)) {
            let sum = 0;
            data.forEach(item => {
              sum += Number(item[column.property]);
            });
            sums[index] = sum;
          } else {
            sums[index] = '';
          }
        }
      });
      return sums;
    },
    dialogFormClick () {
      this.$emit('dialogFormClick');
    }
  }
};
